import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import message from "../../assets/images/helpcenter/notification.png";

import "./help_styles/helpactivity.css";

export default function HelpActivity() {
  const data = [
    {
      time: "Article created 4 hours ago",
      post:
        "The recently popular Internet AI: ChatGPT has actually written The Plan to Destroy Humanity",
      link: "Detail",
    },
    {
      time: "Article created 4 hours ago",
      post:
        "The recently popular Internet AI: ChatGPT has actually written The Plan to Destroy Humanity",
      link: "Detail",
    },
    {
      time: "Article created 4 hours ago",
      post:
        "The recently popular Internet AI: ChatGPT has actually written The Plan to Destroy Humanity",
      link: "Detail",
    },
    {
      time: "Article created 4 hours ago",
      post:
        "The recently popular Internet AI: ChatGPT has actually written The Plan to Destroy Humanity",
      link: "Detail",
    },
    {
      time: "Article created 4 hours ago",
      post:
        "The recently popular Internet AI: ChatGPT has actually written The Plan to Destroy Humanity",
      link: "Detail",
    },
    {
      time: "Article created 4 hours ago",
      post:
        "The recently popular Internet AI: ChatGPT has actually written The Plan to Destroy Humanity",
      link: "Detail",
    },
    {
      time: "Article created 4 hours ago",
      post:
        "The recently popular Internet AI: ChatGPT has actually written The Plan to Destroy Humanity",
      link: "Detail",
    },
    {
      time: "Article created 4 hours ago",
      post:
        "The recently popular Internet AI: ChatGPT has actually written The Plan to Destroy Humanity",
      link: "Detail",
    },
    {
      time: "Article created 4 hours ago",
      post:
        "The recently popular Internet AI: ChatGPT has actually written The Plan to Destroy Humanity",
      link: "Detail",
    },
  ];
  return (
    <>
      <Container className="mt-5 mb-5 help_activity">
        <Row>
          <Col className="d-flex flex-column align-items-center">
            <h2>RECENT ACTIVITY</h2>
            <p>Ask anything about blockchain, Web3 and cryptocurrency</p>
          </Col>
        </Row>
        <Row>
          {data.map((data) => {
            return (
              <>
                <Col lg={4} md={6} className="mt-3 mb-3 help_activity_col">
                  <div className="d-flex justify-content-end gap-2">
                    <img src={message} alt="" style={{ width: "10%" }} />
                    <div className="up_activity_box">
                      <span>{data.time}</span>
                    </div>
                  </div>
                  <div className="low_activity_col">
                    <h5 className="text-therecently">{data.post}</h5>
                  </div>
                  <div className="text-start">
                  <a href="">
                    {data.link}
                  </a>
                  </div>
                </Col>
              </>
            );
          })}
          {/* <Col lg={4}>
            <div className='d-flex justify-content-end gap-2'>
            <img src={message} alt="" style={{width:'10%'}} />
            <div className="up_activity_box">
              <span>Article created 4 hours ago</span>
            </div>
            </div>
            <div className="low_activity_col">
              <h5 className='text-therecently'>The recently popular Internet AI: ChatGPT has actually written:
                 "The Plan to Destroy Humanity"
              </h5>
            </div>
            <a href="" className='text-start'>Detail</a>
          </Col> */}
        </Row>
      </Container>
    </>
  );
}
